import { render, staticRenderFns } from "./my-workflows.vue?vue&type=template&id=0cfb6f5c"
import script from "./my-workflows.vue?vue&type=script&lang=js"
export * from "./my-workflows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports